// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {ButtonEl} from 'common/components/button';
import {TooltipEl} from 'common/components/tooltip';
import {SelectEl} from 'common/components/select';
import {Directions} from 'common/components/drop-menu/types';

import {CopyType} from './types';
import type {CopyToClipboardButton} from './index';
import styles from './index.module.styl';

export function template(this: CopyToClipboardButton) {
  const icon = this.attr(`icon`) || (this.attr(`copy-type`) === CopyType.Copy ? `copy` : `link`);

  if (this.attr(`options`).length === 1) {
    return (
      <div sel={selx(styles.copyToClipboardButtonContainer)}>
        <div sel={selx(styles.copyToClipboardButton)}>
          <ButtonEl
            attrs={{
              ...this.attrs(),
              icon,
            }}
            on={{
              click: () => this.helpers.copyValue(this.attr(`options`)[0].value),
            }}
          >
            {this.innerHTML.trim() && <slot />}
          </ButtonEl>
        </div>
        <TooltipEl
          attrs={{
            'max-width': `64px`,
            text: this.t(`components.copy-to-clipboard.copy`),
          }}
        />
      </div>
    );
  }

  return (
    <SelectEl
      sel={selx(styles.copyToClipboardSelect)}
      attrs={{
        'icon-only': true,
        icon: {leftIcon: icon},
        'menu-width': 200,
        'menu-alignment': Directions.Up,
      }}
      props={{
        sections: [{items: this.attr(`options`).map((option) => ({label: option.label, value: option.value}))}],
      }}
      on={{change: (ev) => this.helpers.copyValue(ev.detail.item.value)}}
    />
  );
}
